export default {
  desktopWidth: '1024px',
  desktopWidthInt: 1024,
};
